export default __webpack_public_path__ + "static/media/banner-bottom.ed84d414.jpg";